import React, { useState, useEffect, Children } from "react";
import { DataForm } from "../../../libs/react-mpk/components";
import { TableWrapper } from "../../../libs/react-mpk/wrapper"
import { toast } from "../../../libs/react-mpk/services"
import { inject, observer } from "mobx-react";
import service, { addDataSftp, getDataSftp, editDataSftpById } from "./TabelSftp.service";
import { find } from "lodash";

const { inputTypes } = DataForm;
const AddSftp = ({ visible = false, onRequestClose = null, item, ...props }) => {
    const [ready, setReady] = useState(false)
    useEffect(() => {
        if (visible)
            setReady(true)
    }, [visible])
    return ready && (
        <DataForm
            baseId="add-sftp"
            title="Tambah Sftp"
            asDialog={true}
            visible={visible}
            onRequestClose={() => {
                setReady(false)
                onRequestClose()
            }}
            defaultData={
                item || {
                    host: "",
                    port: "",
                    username: "",
                    password: "",
                    pathFile: "",
                }
            }
            definitions={[
                {
                    inputType: inputTypes.INPUT,
                    label: "Host",
                    key: "host",
                    required: true
                },
                {
                    inputType: inputTypes.INPUT_MASK_NUMBER,
                    label: "Port",
                    key: "port",
                    required: true,
                },
                {
                    inputType: inputTypes.INPUT,
                    label: "Username",
                    key: "username",
                    required: true
                },
                // {
                //     inputType: inputTypes.INPUT,
                //     label: "Password",
                //     key: "password",
                //     required: true
                // },
                {
                    inputType: inputTypes.INPUT,
                    label: 'Password',
                    key: "password",
                    // minLength: 8,
                    type: 'password',
                    required: true,
                    // show: item?false:true
                },
                {
                    inputType: inputTypes.INPUT,
                    label: "File Path",
                    key: "pathFile",
                    required: true
                }


            ]}
            onSubmit={async (data, callback) => {
                try {
                    let dataList = await getDataSftp({ page: 0, size: 50 })
                    if( !item && dataList && dataList.data.length > 0){
                        callback('Data Setting SFTP hanya bisa di input 1 saja!!!', true)
                    }else{
                        let response = item
                            ? await editDataSftpById(item.id, data)
                            : await addDataSftp(data)
                        TableWrapper.updateDataItem("mod-table-sftp", { id: response.data.id }, response.data)
                        callback(item ? "Data Berhasil Diedit" : "Data Berhasil Ditambah", false)
                    }
                } catch (error) {
                    callback(error.response.data.detail, true)
                }
            }}
        />
    );
};

export default inject("envStore")(observer(AddSftp));
